import { useEffect, useState, useCallback, useSyncExternalStore } from 'react';

export const MOBILE_HEADER_MQ = '(max-width: 48rem)';

export function useMatchesMedia(query: string): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      const mq = window.matchMedia(query);
      mq.addEventListener('change', notify);
      return () => mq.removeEventListener('change', notify);
    },
    [query],
  );
  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
/** Scroll past the hero before the floating pill slides away. */
const RECEDE_SCROLL_Y = 72;

/** True on a narrow viewport once the page has scrolled down — hide the floating pill. */
export function useMobileHeaderRecede(enabled: boolean, blocked = false): boolean {
  const [recede, setRecede] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const mq = window.matchMedia(MOBILE_HEADER_MQ);

    function update() {
      if (!mq.matches || blocked) {
        setRecede(false);
        return;
      }
      setRecede(window.scrollY > RECEDE_SCROLL_Y);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    mq.addEventListener('change', update);

    return () => {
      window.removeEventListener('scroll', update);
      mq.removeEventListener('change', update);
    };
  }, [blocked, enabled]);

  return enabled && !blocked && recede;
}
